export default {
    personImg: {
        src: "/static/img/templates-generator/joel.png"
    },
    name: "Paul Chapman",
    jobDescription: "Chief Executive & Founder",
    personPhotoborderRadius: "50px"
};
